import { AssetRowState } from "../types";
import { IAsset } from "../providers";
import { ProcessingIcon } from "../../../icons";
import { AssetCard } from "./AssetCard";

export interface AssetRowProps {
  title: string;
  count?: number;
  state: AssetRowState;
  numberToShow?: number;
  enableMultiSelect?: boolean;
  onAssetClick: (asset: IAsset) => void;
  onAssetSelect?: (assetId: string) => void;
  onViewAll: () => void;
  selectedAssets?: string[];
  /** IDs visually highlighted by an in-progress drag selection */
  dragHighlightedIds?: string[];
}

export const AssetRow = ({ title, count, state, numberToShow = 6, enableMultiSelect = false, onAssetClick, onAssetSelect, onViewAll, selectedAssets = [], dragHighlightedIds = [] }: AssetRowProps) => {
  const { assets, loading, error } = state;

  // Format the title with count
  const displayTitle = loading ? title : `${title} ${count ? `(${count})` : ''}`;

  return (
    (!loading && !error && assets.length === 0) ? (
      <></>
    ) : (
      <div className="library-view__row">
        <div className="library-view__row-header">
          <h3 className="library-view__row-title">{displayTitle}</h3>
          <button
            className="btn btn-small btn-link"
            onClick={onViewAll}
            type="button"
          >
            View all
          </button>
        </div>

        <div className="library-view__row-content">
          {loading && (
            <div className="library-view__loading">
              <ProcessingIcon />
            </div>
          )}

          {error && (
            <div className="library-view__error">
              {error}
            </div>
          )}

          {!loading && !error && assets.length > 0 && (
            <div className="library-view__assets">
              {assets.slice(0, numberToShow).map((asset) => (
                <AssetCard
                  key={asset.getId()}
                  asset={asset}
                  enableMultiSelect={enableMultiSelect}
                  isSelected={selectedAssets.includes(asset.getId())}
                  isDragHighlighted={dragHighlightedIds.includes(asset.getId())}
                  showStatusPill={true}
                  showTitle={true}
                  onClick={() => {
                    if (onAssetSelect) {
                      onAssetSelect(asset.getId());
                    }
                    onAssetClick(asset);
                  }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    )
  );
};